export const BensServicosTabIds = {
  paravoce: 0,
  parasuaempresa: 1,
};
